<template>
  <li class="list-item incr-tene">
    <x-angleIcon></x-angleIcon>
    <h3><i class="iconfont iconicon_jiantou"></i>新增住户趋势图</h3>
    <div class="tenment" id="tenment"></div>
  </li>
</template>

<script>
import chartOpt from '@/utils/chartOptions';
export default {
  name: 'newincreased',
  data () {
    return {
      cId: ''
    };
  },
  created () {
    this.getDataViewQuery(this);
  },
  mounted () {
    this.tenmentChart();
  },
  methods: {
    /* 每天住户新增的走势图 */
    async tenmentChart () {
      this.newUser = this.Highcharts.chart('tenment', {...chartOpt.columnOptions});
      this.getNewUser();
    },
    /* 获取新增用户 */
    getNewUser () {
      return new Promise((resolve, reject) => {
        this.$get({
          url: '/zw_statistics/householder_statistics',
          params: {community_id: this.cId},
          config: { timeout: 20000 }
        }).then(({data}) => {
          let date = [];
          let value = [];
          data && data.forEach((ele) => {
            date.push(ele.date);
            value.push(ele.value);
          });
          this.newUser.xAxis[0].setCategories(date);
          this.newUser.series[0].setData(value);
        });
      });
    }
  }
};
</script>

<style scoped>
  #tenment {
    height: 100%;
  }
</style>
